import { FormlyFieldConfig } from '@ngx-formly/core';

export const toggleInputForm: FormlyFieldConfig[] = [
  {
    wrappers: ['row'],
    className: 'form-wrapper--row',
    fieldGroup: [
      {
        key: 'defaultValue',
        type: 'select',
        defaultValue: false,
        props: {
          translate: true,
          label: 'formGenerator.uiElement.toggle.defaultValue',
          options: [
            {
              name: 'false',
              id: false,
            },
            {
              name: 'true',
              id: true,
            },
          ],
        },
      },
      {
        key: 'props.labelTrueValue',
        type: 'input',
        props: {
          translate: true,
          label: 'formGenerator.uiElement.toggle.labelTrue',
        },
      },
      {
        key: 'props.labelFalseValue',
        type: 'input',
        props: {
          translate: true,
          label: 'formGenerator.uiElement.toggle.labelFalse',
        },
      },
    ],
  },
];
